export default __webpack_public_path__ + "2eaff7cddf1e7bd3198ae928649583ad.png";